export const RECEIVE_PURCHASE_ORDERS = "RECEIVE_PURCHASE_ORDERS";
export const CREATE_PURCHASE_ORDERS = "CREATE_PURCHASE_ORDERS";
export const REMOVE_PURCHASE_ORDERS = "REMOVE_PURCHASE_ORDERS";
export const FILTER_PURCHASE_ORDERS = "FILTER_PURCHASE_ORDERS";



// WEBPACK FOOTER //
// ./src/features/trade_documents/purchaseOrdersActionTypes.js